<script setup lang="ts">
defineProps<{ event: EventCard }>();
</script>

<template>
  <CardsEventInfoCell
    v-if="event.website"
    icon="far:hexagon"
    class="group"
  >
    <span class="text-green-50 group-hover:underline">
      Konferansens nettside
    </span>
  </CardsEventInfoCell>
</template>
